import {Injectable} from '@angular/core';
import {FeatureFlag} from '@emma-labs/shared/typescript';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class FeatureFlagService {
  abstract initialize(key?: string): Observable<void>;

  abstract reinitialize(key?: string): Observable<void>;

  abstract isEnabled(
    ff: FeatureFlag,
    params?: {[key: string]: string | number | boolean},
  ): Observable<boolean>;
}
